module.exports = __webpack_public_path__ + "img/oil-mobile.05984c36.png";